import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord, useCloneEntity, makeResetCache } from 'gossamer-front-end';
import { ControlAbsenceReasonField } from './ControlAbsenceReasonField';
import { Attendance, BookingView, BookingExtendedView } from 'cb-model';

export const AttendanceUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const LocalAttendance = useCloneEntity(Attendance);
  const record = useCacheRecord(Attendance, params.key);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  LocalAttendance.fields.flags.editable = false;
  LocalAttendance.fields.flag_reasons.editable = false;

  return (
    <>
      <PageTitle title="Update Attendance" entity={LocalAttendance} />
      <FormManager
        compoundUrl="/main/~/attendance-update"
        handleCancel={() => navigate(-1)}
        handleSuccess={() => {
          resetCache(Attendance.id);
          resetCache(BookingView.id);
          resetCache(BookingExtendedView.id);
          navigate(-1);
        }}
        initialization={{
          main: { type: 'update-single', entity: LocalAttendance, record },
        }}
      >
        <ControlAbsenceReasonField localAttendance={LocalAttendance} />
        <Update valuesKey="main" entity={LocalAttendance} />
      </FormManager>
    </>
  );
};
